import { axiosInstanceWithToken } from "@/utils/axios";
import { HOST_API_KEY } from "../../config";

export const postReportComment = async (data) => {
  const request = await axiosInstanceWithToken.post(`${HOST_API_KEY}/report/comment`, data);
  return request;
};

export const postReportPost = async (data) => {
  const request = await axiosInstanceWithToken.post(`${HOST_API_KEY}/report/post`, data);
  return request;
};

export const postReportUser = async (data) => {
  const request = await axiosInstanceWithToken.post(`${HOST_API_KEY}/report/user`, data);
  return request?.data;
};

export const postReportMediaUpload = async (data) => {
  const request = await axiosInstanceWithToken.post(
    `${HOST_API_KEY}/report/media/upload`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return request?.data;
};
